
export const LAYER_NAMES: Record<string, string> = {
  "/geo-data/areas_basin_Ros.geojson": "Басейн",
  "/geo-data/gts_river_ROS.geojson": "Гідротехнічні споруди для ліквідації",
  "/geo-data/HES_Ros.geojson": "ГЕС",
  "/geo-data/waterbody_poyline_Ros.geojson": "Поверхневі води",
  "/geo-data/river_line_Ros.geojson": "Поверхневі води",
  "Моніторинг": "Моніторинг",
};

export enum FEATURE_DETAILS_COMPONETN_TYPES {
  DEFAULT = "default",
  MONITORING = "monitoring"
}

export const FEATURE_DETAILS_COMPONENT: Record<string, string> = {
  "Басейн": "default",
  "Гідротехнічні споруди для ліквідації": "default",
  "ГЕС": "default",
  "Поверхневі води": "default",
  "Річище": "default",
  "Водні об'єкти": "default",
  "Моніторинг": "monitoring"
}

export const LAYER_FILES_URL = [
  "/geo-data/areas_basin_Ros.geojson",
  "/geo-data/gts_river_ROS.geojson",
  "/geo-data/HES_Ros.geojson",
  "/geo-data/river_line_Ros.geojson",
  "/geo-data/waterbody_poyline_Ros.geojson",
]

export enum PLAN_STATUS_ENUM {
  completed = 'виконано',
  inProgress = 'виконується',
  notCompleted = 'не виконано',
  ongoing = 'постійно'
}

export const PLAN_STATUS: Record<string, string> = {
  виконано: 'completed',
  виконується: 'inProgress',
  "не виконано": 'notCompleted',
  постійно: 'ongoing'
}
